<template>
  <div class="tableparentdiv">
    <p class="text-danger text-center pt-1 pb-0">
      <i>
        {{$t("Эслатма! чоп этиш учун товар сони 200 тадан ошмаслиги керак!")}}
      </i>
    </p>
    <table class="create_table">
      <thead>
        <tr>
          <th style="width: 503px">Товар</th>
          <th style="width: 501px">{{$t('Нарх')}} <input type="checkbox" v-model="price"></th>
          <th style="width: 500px">{{$t('Cони')}} 
            <button style="float: right;" type="button" :disabled="limit" class="btn btn-primary" @click='Print()'>
              <b-icon icon="printer"></b-icon>
            </button>
            <button style="float: right;" type="button" class="btn btn-success" @click='Clear()'>
              {{$t('Тозалаш')}}
            </button>
          </th>
        </tr>
      </thead>
      <tbody style="overflow: hidden;">
        <VueAutoVirtualScrollList
          :totalHeight="690"
          class="virtual"
          :defaultHeight="50"
          style="calc(100% - 100px)!important;height: 93vh!important;overflow-y: scroll;"
        >
          <tr :style="{ height: `${index / 1000 + 10}px` }" 
            v-for="(item, index) in datas.initial_balance_table" :key="index"
          >
            <td>
              {{item.product.extra_name}}
            </td>
            <td>
              {{item.chakana_price}}
            </td>
            <td>
              <input type="number" @input="item.count=parseInt(item.count), Summa()" v-model="item.count">
            </td>
          </tr>
        </VueAutoVirtualScrollList>
      </tbody>
    </table>
    <!-- <div style="width: 200px;"> -->
    <!-- <center>{{datas.initial_balance_table[0].product.extra_name}}</center> -->
    <!-- <barcode :value="datas.initial_balance_table[0].shtrix_kod"></barcode> -->
    <!-- <center v-if="price==true" style="font-size: 14pt;">{{datas.initial_balance_table[0].chakana_price|numFormat0}}</center> -->
  <!-- </div> -->
    <div class="mybody" style="display: none;">
      <!-- <div style="width: 200px;"> -->
      <span v-for="(item, index) in datas.initial_balance_table" :key="index">
        <div v-if="item.shtrix_kod!=''" v-for="n in item.count" :key="n">
          <div class="page" v-if="price!=true">
            <center style="height: 28vh;">{{item.product.extra_name}}</center>
            <barcode fontSize="40" width="3" height="110px" :value="item.shtrix_kod"></barcode>
            <center v-if="price==true" >{{item.chakana_price|numFormat0}} cўм</center>
          </div>
          <div class="page price" v-else>
            <center style="height: 24vh;" >{{item.product.extra_name}}</center>
            <div class="pricebarcode">
              <b class="pricetext">{{item.chakana_price|numFormat0}}</b>
              <div style="width: 80px !important;display: block;">
                <!-- <p>00</p><hr class="hr"> -->
                <p>cўм</p>
              </div>
            </div>
            <barcode width="2" height="48px" :value="item.shtrix_kod"></barcode>
          </div>
        </div>
      </span>
    <!-- </div> -->
    </div>
</div>
</template>
<style>
  .vue-barcode-element{
    width: 140%!important;
    height: 44vh;
  }
  .pricebarcode p{
    text-align: center;
  }
  .pricebarcode{
    display: inline-flex;
    width: 150%!important;
  }
  .price .vue-barcode-element{
    width: 140%!important;
    height: 30vh;
  }
  .price p{
    font-size: 50pt;
  }
  .page.price>center{
    font-size: 70pt!important;
  }
  .mybody{
    /* margin: -40% 0!important; */
  }
  /* .page.price center{ */
    /* width: 165%!important; */
  /* } */
  .page center{
    /* zoom: 1; */
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    line-height: 1;
    font-weight: bold;
    width: 145%!important;
    font-size: 110pt!important;
  }
  .pricetext{
    text-align: center;
    width: 80%;
    line-height: 1;
    font-weight: 100;
    font-size: 200pt!important;
  }
  .page{
    page-break-after: always;
    page-break-inside: avoid;
    padding: 0!important;
    /* width: 145%!important; */
    /* width: 1000px; */
    transform: rotate(90deg);
  }
  /* .vue-barcode-element text{
    text-align: center;
    font-size: 20pt!important;
  } */
</style>
<script>
import $ from "jquery";
import VueBarcode from 'vue-barcode';
import * as htmlToImage from "html-to-image";
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from "html-to-image";
import electronVuePrinter from "electron-vue-printer";
import VueAutoVirtualScrollList from "vue-auto-virtual-scroll-list";
export default {
  name: "Print",
  components: { 'barcode': VueBarcode, VueAutoVirtualScrollList },
  data() {
    return {
      price:false,
      datas: [],
      mysklad: [],
      rotateType: 0,
      summ: 0,
      limit: false,
      options: {
        offsetX: 0,
        offsetY: 0,
        imageWidth: 300
      },
      qarz: 0
    };
  },
  created: function() {
    this.Data();
  },
  mounted: function() {
  },
  methods: {
    Print(){
      var head = $(".mybody").html();
      if (head == undefined) {
        head = "";
      }     
      // window.document.body.style.width='20mm';
      window.document.body.innerHTML = head;
      window.print();
      window.location.reload();
    },
    Clear(){
      let self=this;
      self.datas.initial_balance_table.forEach(function(key, value) {
        key.count=0;
      });
      self.Summa();
    },
    Data() {
      let self = this;
      axios
        .get("api/v1/initial-balance/id/" + self.$route.params.id)
        .then(function(response) {
          self.datas = response.data;
          self.Summa();
        });
    },
    Summa(){
      this.summ = 0;
      this.datas.initial_balance_table.forEach( (element) => {
        this.summ += element.count;
      });
      if(this.summ > 200){
        this.limit = true;
      } else {
        this.limit = false; 
      }
    }
  },
  // computed: {
  //   filteredBalance() {
  //     return this.datas.initial_balance_table != undefined ? this.datas.initial_balance_table.slice(0, 50) : [];
  //   },
  // },
  watch: {
    "$store.state.changed": function() {
      if (this.$store.state.changed != null) {
        this.Ostatka(this.$store.state.selected_index);
        this.$store.state.changed = null;
      }
    }
  }
};
</script>
